<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex';
import ComponentAveragesChart from '@/helpers/ComponentAveragesChart';
import range from "lodash.range"

const components = ['1a', '1e', '2a', '2d', '3b', '3c', '3d', '4e']

@Component({
    components: {
        ComponentAveragesChart
    },
    props: {
        componentsInfo: Object
    },
    computed: {
        ...mapGetters({
            fiscalYear: 'getFiscalYear',
            userRole: "getUserRole"
      })
    }
})

export default class ComponentAveragesChartContainer extends Vue {

    dataCollection = null
    display = null

    mounted(){

        this.updateChart()

    }

    createComponentsArrayByYear (_arr, obj) {
        const components = obj

        let arr = []

        let applicableYears = [
            this.fiscalYear - 2,
            this.fiscalYear - 1,
            this.fiscalYear
        ]

        for (let prop in components) {

            let obj = {
                fiscalYear: parseInt(prop), 
                averages: []
            }

            for (let prop2 in components[prop].components){
                for(let i=0; i< _arr.length; i++){
                    if (prop2 === _arr[i]) {
                        var _obj = {}
                        _obj[prop2] = components[prop].components[prop2].data.average
                        obj.averages.push(_obj)
                    }
                }
            }
            arr.push(obj)
        }
        
        let appliedYears = []

        for (let j = 0; j < applicableYears.length; j++) {


            let result = arr.find(f => f.fiscalYear === applicableYears[j])

            if (result) {
                appliedYears.push(result)
            } else {
                let obj = {}
                obj.averages = range(8).map(i => 0)
                appliedYears.push(obj)
            }

        }

        return appliedYears

    }

    createComponentsValues(_arr) {
        let arr = []

        for(let j=0; j < _arr.length; j++){
            
            let arr3 = []

            for(let k=0; k < _arr[j].averages.length; k++) {
                arr3.push(Object.values(_arr[j].averages[k])[0])
            }
            arr.push(arr3)
        }

        return arr
    }

    updateChart() {

        const arr = this.createComponentsArrayByYear(components, this.componentsInfo)

        let values = this.createComponentsValues(arr)

        this.dataCollection.datasets[0].label = `${this.fiscalYear-3}-${this.fiscalYear-2}`
        this.dataCollection.datasets[1].label = `${this.fiscalYear-2}-${this.fiscalYear-1}`
        this.dataCollection.datasets[2].label = `${this.fiscalYear-1}-${this.fiscalYear}`

        for (let x=0; x < this.dataCollection.datasets.length; x++){
            switch(x) {
                case 0:
                    this.dataCollection.datasets[x].data = values[x]
                    break;
                case 1: 
                    this.dataCollection.datasets[x].data = values[x]
                    break;
                case 2: 
                    this.dataCollection.datasets[x].data = values[x]
                    break;
            }
        }
        
        this.display = true
    
    }

    dataCollection = {
        labels: [
            ["1a. Demonstrating", "Knowledge", "of Content &", "Pedagogy"],
            ["1e. Designing", "Coherent", "Instruction"],
            ["2a. Environment", "of Respect &", "Rapport"],
            ["2d. Managing", "Student Behavior"],
            ["3b. Using", "Questioning &", "Discussion"],
            ["3c. Engaging", "Students in", "Learning"],
            ["3d. Using", "Assessment in", "Instruction"],
            ["4e. Growing &", "Developing", "Professionally"]
        ],
        datasets: [
            {
                backgroundColor: '#e7dbee',
                borderColor: '#979797',
                borderWidth: 1,
                data: []
            },
            {
                backgroundColor: '#ae94bd',
                borderColor: '#979797',
                borderWidth: 1,
                data: []
            },
            {
                backgroundColor: '#613f75',
                borderColor: '#979797',
                borderWidth: 1,
                data: []
            }
        ]
    }

}

</script>

<template>
    <div>
        <div class="components-chart-container">
            <h2 class="components-chart-title">Comparing Your Past Component Averages</h2>
            <ComponentAveragesChart v-if="display"
                :chart-data="dataCollection"
                :width="600"
                :height="360">
            </ComponentAveragesChart>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    div {
        .components-chart-title {
            font-size: 30px;
            font-weight: normal;
            margin-left: 40px;
        }
    }
</style>